import React from 'react';
import { TabsList, TabsTrigger } from '../ui/tabs';
import { cn } from '@/lib/utils';
import { ADMIN_NAV_GROUPS, ADMIN_NAV_FOOTER } from './adminNavConfig';

const navTriggerClass = cn(
  'inline-flex w-full items-center justify-start gap-3 rounded-lg px-3 py-2.5 text-sm font-medium',
  'text-gray-400 transition-colors',
  'hover:bg-[#2D3748]/50 hover:text-white',
  'data-[state=active]:bg-blue-600 data-[state=active]:text-white data-[state=active]:shadow-none',
  'focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:ring-offset-[#1A2332]',
);

function NavItem({ value, label, icon: Icon }) {
  return (
    <TabsTrigger value={value} className={navTriggerClass}>
      <Icon className="h-4 w-4 shrink-0 opacity-90" aria-hidden />
      <span className="truncate">{label}</span>
    </TabsTrigger>
  );
}

function NavSection({ label, children }) {
  return (
    <div className="space-y-1">
      <p className="px-3 pb-1 text-[10px] font-semibold uppercase tracking-widest text-gray-500">
        {label}
      </p>
      <div className="space-y-0.5">{children}</div>
    </div>
  );
}

const AdminSidebar = () => {
  const FooterIcon = ADMIN_NAV_FOOTER.icon;

  return (
    <aside
      className="sticky top-[73px] flex h-[calc(100vh-73px)] w-[260px] shrink-0 flex-col border-r border-[#2D3748] bg-[#1A2332]"
      aria-label="Navigation administration"
    >
      <TabsList className="flex h-full min-h-0 flex-col items-stretch justify-between gap-0 overflow-hidden rounded-none border-0 bg-transparent p-0">
        <nav className="flex-1 space-y-6 overflow-y-auto overscroll-contain px-3 py-4">
          {ADMIN_NAV_GROUPS.map((group) => (
            <NavSection key={group.id} label={group.label}>
              {group.items.map((item) => (
                <NavItem key={item.value} {...item} />
              ))}
            </NavSection>
          ))}
        </nav>

        <div className="shrink-0 border-t border-[#2D3748] bg-[#141c2b] px-3 py-3">
          <p className="px-3 pb-2 text-[10px] font-semibold uppercase tracking-widest text-gray-500">
            Système
          </p>
          <TabsTrigger value={ADMIN_NAV_FOOTER.value} className={navTriggerClass}>
            <FooterIcon className="h-4 w-4 shrink-0 opacity-90" aria-hidden />
            <span className="truncate">{ADMIN_NAV_FOOTER.label}</span>
          </TabsTrigger>
          {ADMIN_NAV_FOOTER.description ? (
            <p className="mt-2 px-3 text-[11px] leading-snug text-gray-500">
              {ADMIN_NAV_FOOTER.description}
            </p>
          ) : null}
        </div>
      </TabsList>
    </aside>
  );
};

export default AdminSidebar;
